/*
 * DeluxeCovers Swedish storefront translations
 * -----------------------------------------------
 * This file translates hardcoded text from both assets/custom.js and the
 * legacy homepage on the Swedish storefront.
 *
 * Prices, product fetching, discounts, product links and layout are untouched.
 *
 * EASY UPDATES:
 * - Edit only the Swedish value on the RIGHT side below.
 * - The Danish text on the LEFT must match the original Danish text exactly.
 * - Use <br> where you want to keep an existing line break.
 */
(function () {
  'use strict';

  var isSwedishStorefront =
    (window.Shopify && String(window.Shopify.country || '').toUpperCase() === 'SE') ||
    /^sv(?:-|$)/i.test(document.documentElement.lang || '') ||
    /(^|\.)deluxecovers\.se$/i.test(window.location.hostname);

  if (!isSwedishStorefront) return;

  var SWEDISH_TEXT = {
    "Ladestation /<br>trådløs oplader": "Laddstation /<br>trådlös laddare",
    "Headset &<br>hovedtelefoner": "Headset &<br>hörlurar",
    "Headset": "Hörlurar",
    "MagSafe<br>tilbehør": "MagSafe-<br>tillbehör",
    "USB oplader<br>til mobil": "USB-laddare<br>till mobil",
    "Kabel &<br>adaptere": "Kabel &<br>adaptrar",
    "Powerbank<br>stort udvalg": "Powerbank<br>stort utbud",
    "Tilbehør til iPhone": "Tillbehör till iPhone",
    "Holder til bil<br>biltilbehør": "Mobilhållare<br>& biltillbehör",
    "NX 360° cover M.<br>beskyttelseglas": "NX 360°-skal med<br>skyddsglas",
    "Lænkeværktøj 2.0<br>til skift af led": "Länkverktyg 2.0<br>för byte av länkar",
    "Magnetisk trådløs<br>oplader - 1M": "Magnetisk trådlös<br>laddare - 1 m",
    "Apple Watch<br>night stand - Sort": "Apple Watch-<br>nattställ - Svart",
    "DeLX™ 3-i-1<br>ladestation - Sort": "DeLX™ 3-i-1-<br>laddstation - Svart",
    "CNC aluminium<br>oplader stand": "CNC-laddställ<br>i aluminium",
    "Tilbehør til Apple Watch": "Tillbehör till Apple Watch",
    "Holder til bil<br>Biltilbehør": "Mobilhållare<br>& biltillbehör",
    "Kabel &<br>Adaptere": "Kabel &<br>adaptrar",
    "Powerbank<br>Stort udvalg": "Powerbank<br>stort utbud",
    "Tilbehør til Samsung": "Tillbehör till Samsung",
    "Se alle produkter >": "Se alla produkter >",
    "DeLX™ 3-i-1<br>Ladestation - Sort": "DeLX™ 3-i-1-<br>laddstation - Svart",
    "X97 Magnetisk Mobilholder": "X97 magnetisk mobilhållare",
    "ESSAGER™ 45W<br>USB Biloplader": "ESSAGER™ 45W<br>USB-billaddare",
    "GaN-Pro™ 240W<br>USB Ladestation": "GaN-Pro™ 240W<br>USB-laddstation",
    "65W QuickCharge<br>Vægoplader": "65W QuickCharge-<br>väggladdare",
    "JOYROOM™ 3-i-1 Ladestation": "JOYROOM™ 3-i-1-laddstation",
    "3-i-1 Trådløs<br>Oplader - Sort": "3-i-1 trådlös<br>laddare - Svart",
    "Mest Populære i oplader": "Mest populärt inom laddare",
    "Professionel Drone<br>4K - GPS": "Professionell drönare<br>4K - GPS",
    "Multifunktionel<br>Bodytrimmer V.3.0": "Multifunktionell<br>kroppstrimmer V.3.0",
    "DeLX™ | 3-i-1<br>Ladestation 15W": "DeLX™ | 3-i-1-<br>laddstation 15W",
    "XDOBO™<br>Bluetooth-højtaler": "XDOBO™<br>Bluetooth-högtalare",
    "4K Ultra HD<br>Dashcam": "4K Ultra HD-<br>dashcam",
    "Multistyler<br>6-i-1 Professionel": "Multistyler<br>6-i-1 Professionell",
    "ROCK™ HIFI<br>Trådløs Headset": "ROCK™ HIFI<br>Trådlöst headset",
    "Carplay Adapter<br>til bil Carabc™": "CarPlay-adapter<br>till bil Carabc™",
    "ACTION-5K HD<br>Action Kamera": "ACTION-5K HD<br>actionkamera",
    "SkyPro™ Mini 4K<br>Letvægtsdrone": "SkyPro™ Mini 4K<br>lättviktsdrönare",
    "MotionMate™<br>Aktivitetsur IP68": "MotionMate™<br>aktivitetsklocka IP68",
    "Sovemaske 100%<br>mørklægning": "Sovmask med 100 %<br>mörkläggning",
    "Mest populære gadgets": "Mest populära gadgets",
    "Magcold™ 3-i-1<br>Ladestation": "Magcold™ 3-i-1-<br>laddstation",
    "Lenovo™ LP40<br>trådløst Headset": "Lenovo™ LP40<br>trådlöst headset",
    "YESIDO® - 15W<br>Trådløs Biloplader": "YESIDO® - 15W<br>trådlös billaddare",
    "MagSafe Powerbank<br>5.000mAh": "MagSafe-powerbank<br>5.000 mAh",
    "PULUZ™<br>Mikrofon (USB-C)": "PULUZ™<br>mikrofon (USB-C)",
    "ESSAGER™<br>20W - Sort": "ESSAGER™<br>20W - Svart",
    "Mobilholder til<br>Instrumentbrættet": "Mobilhållare för<br>instrumentpanelen",
    "Yesido® YPS1<br>20.000 mAh": "Yesido® YPS1<br>20.000 mAh",
    "Qi Magnetisk 3-i-1<br>MagSafe Oplader": "Qi magnetisk 3-i-1-<br>MagSafe-laddare",
    "HAWEEL® Justerbar<br>Mobil holder": "HAWEEL® justerbar<br>mobilhållare",
    "Lenovo® LP40 Pro<br>Headset BT 5.1": "Lenovo® LP40 Pro<br>headset BT 5.1",
    "POPULÆRT MOBIL TILBHEØR": "POPULÄRA MOBILTILLBEHÖR",
    "Mobil Ladestation": "Mobil laddstation",
    "Trådløs oplader": "Trådlös laddare",
    "Mobilholder til bil": "Mobilhållare till bil",
    "Mobil kabel": "Mobilkabel",
    "Mobil løbeudstyr": "Löpartillbehör för mobil",
    "Cykel mobilholder": "Mobilhållare för cykel",
    "Mest Populære Tilbehør": "Mest populära tillbehör",
    "USB<br>Oplader": "USB-<br>laddare",
    "SmartWatch<br>Ur": "Smartwatch-<br>klockor",
    "MagSafe<br>Tilbehør": "MagSafe-<br>tillbehör",
    "Løbearmbånd<br>& træning": "Löpararmband<br>& träning",
    "Kamera<br>droner": "Kamera-<br>drönare",
    "Powerbank<br>m. solcelle": "Powerbank<br>med solcell",
    "Gadgets<br>til bilen": "Gadgets<br>till bilen",
    "Dashcam<br>4K UHD": "Dashcam<br>4K UHD",
    "Rejse<br>Gadgets": "Rese-<br>gadgets",
    "Computer<br>Rygsække": "Dator-<br>ryggsäckar",
    "AirTag<br>Tilbehør": "AirTag-<br>tillbehör",
    "AirPods<br>Tilbehør": "AirPods-<br>tillbehör",
    "Bestseller kategorier": "Bästsäljande kategorier",
    "ROCK™ Over Ear<br>Headset BT 5.0": "ROCK™ Over-ear-<br>headset BT 5.0",
    "Lenovo™ 4Run<br>Fitness Buds": "Lenovo™ 4Run<br>Fitness Buds",
    "JOYROOM™<br>BT Højtaler": "JOYROOM™<br>BT-högtalare",
    "KUMI™ T9S<br>Touch Headset": "KUMI™ T9S<br>touch-headset",
    "MONO Håndfri<br>Øresnegl M. Etui": "MONO handsfree-<br>headset med etui",
    "Mest Populære i Audio og HiFi": "Mest populärt inom ljud och HiFi",
    "DeLX™ MagSafe Silikone Cover": "DeLX™ MagSafe-silikonskal",
    "DG.MING™ Vintage 2-I-1 Cover": "DG.MING™ Vintage 2-i-1-fodral",
    "Vintage 2-In-1 Læder Etui": "Vintage 2-i-1-läderfodral",
    "CaseMe™ Noble læder Etui": "CaseMe™ Noble läderfodral",
    "NX Design™ Læder Cover": "NX Design™ läderfodral",
    "Ultratynd Matte Cover V.2.0": "Ultratunt matt skal V.2.0",
    "Mest Populære iPhone Cover": "Mest populära iPhone-skal",
    "Indlæser pris...": "Laddar pris...",
    "L'Empiri™ Verona Ægte Læder": "L'Empiri™ Verona äkta läder",
    "L'Empiri™ Milanese Loop - Sølv": "L'Empiri™ Milanese Loop - Silver",
    "L'Empiri™ Nylon Velcro Rem": "L'Empiri™ kardborrearmband",
    "4Run™ Silikone Sportsrem - Hvid": "4Run™ silikonrem - Vit",
    "L'Empiri™ Premium 316L Stål - Sort": "L'Empiri™ Premium 316L stål - Svart",
    "L'Empiri™ X35 Titanium Rem": "L'Empiri™ X35 titanarmband",
    "Mest Populære i Apple Watch": "Mest populärt till Apple Watch",
    "Verona™ Multietui Ægte Læder": "Verona™ multifodral i äkta läder",
    "Retro Diary™ 360° Onefold": "Retro Diary™ 360° Onefold",
    "NX Design™ Trifold Cover": "NX Design™ Trifold-fodral",
    "ToughCase™ 360° Håndværker Cover": "ToughCase™ 360° robust skyddsfodral",
    "Neopren Stødsikkert Sleeve": "Stöttåligt sleeve i neopren",
    "DUX DUCIS™ Tastatur Cover": "DUX DUCIS™ tangentbordsfodral",
    "Mest Populære i iPad": "Mest populärt till iPad",
    "Lightning til USB-A Kabel": "Lightning till USB-A-kabel",
    "Lightning til USB-C Kabel": "Lightning till USB-C-kabel",
    "USB-C til USB-C Kabel": "USB-C till USB-C-kabel",
    "USB-C Oplader QC 3.0 - PD 20W": "USB-C-laddare QC 3.0 - PD 20W",
    "USB-C Til USB-A Kabel": "USB-C till USB-A-kabel",
    "Magnetisk Trådløs Oplader m. MagSafe": "Magnetisk MagSafe-laddare",
    "Mest Populære i kabler": "Mest populärt inom kablar",
    "DeLX™ - Kapacitiv Stylus Pen": "DeLX™ - kapacitiv pekpenna",
    "DeLX™ - 3-i-1 Docking Ladestation": "DeLX™ - 3-i-1-laddstation",
    "Lenovo™ LP40 trådløst in-ear Headset": "Lenovo™ LP40 trådlöst in-ear-headset",
    "SENSE™ Trådløs biloplader Automatisk": "SENSE™ automatisk trådlös billaddare",
    "Lightning Oplade Data/Sync Kabel 1M": "Lightning laddnings-/synkkabel 1 m",
    "BASEUS™ Gravity Trådløs Biloplader": "BASEUS™ Gravity trådlös billaddare",
    "Andre kunder har også købt": "Andra kunder har också köpt",
    "Adapter": "Adapter",
    "Oplader & Kabel": "Laddare & kabel",
    "Webcam Tilbehør": "Webbkameratillbehör",
    "Trådløs Mus": "Trådlös mus",
    "Stander / Holder": "Stativ / hållare",
    "Rengøring": "Rengöring",
    "Anbefalet Tilbehør til MacBook": "Rekommenderade tillbehör till MacBook",
    "Webcam cover": "Webbkameraskydd",
    "Anbefalet Tilbehør til Computer": "Rekommenderade tillbehör till dator",
    "DelX S1 Holder<br>Foldbar Design": "DelX S1-hållare<br>vikbar design",
    "DeLX™ Kapacitiv<br>Stylus Pen": "DeLX™ kapacitiv<br>pekpenna",
    "iPad / Tablet<br>Holder til Bil": "iPad-/surfplattehållare<br>till bil",
    "Tilbehør til iPad": "Tillbehör till iPad",
    "NYHED": "NYHET",
    "NYHED<br>": "NYHET<br>",
    "Cover & Tilbehør.": "Skal & tillbehör.",
    "Se mere": "Se mer",
    "GRATIS FRAGT OVER 400KR. | HURTIG LEVERING 1-2 DAGE": "FRI FRAKT ÖVER 600 KR | SNABB LEVERANS 1–4 DAGAR",
    "MOBIL TILBEHØR": "Mobil&shy;tillbehör",
    "WATCH TILBEHØR": "SMARTWATCH-TILLBEHÖR",
    "TABLET TILBEHØR": "Surfplatte&shy;tillbehör",
    "MAC/PC TILBEHØR": "MAC/PC-TILLBEHÖR",
    "Kabler": "Kablar",
    "Oplader": "Laddare",
    "Mobilholder": "Mobilhållare",
    "Gaveidéer": "Presentidéer",
    "Gadgets til bilen": "Gadgets till bilen",
    "GADGETS TIL BILEN": "GADGETS TILL BILEN",
    "Alt i udstyr og gadgets til bil": "Allt inom utrustning och gadgets till bilen",
    "Mobilcovers & tilbehør": "Mobilskal & tillbehör",
    "Populært": "Populärt",
    "iPhone covers": "iPhone-skal",
    "iPhone tilbehør": "iPhone-tillbehör",
    "iPad covers": "iPad-skal",
    "MacBook Sleeves": "MacBook-fodral",
    "Apple Watch Remme": "Apple Watch-armband",
    "Støvsuger til bil": "Bildammsugare",
    "Ladestationer": "Laddstationer",
    "In-ear høretelefoner": "In-ear-hörlurar",
    "USB ladestation": "USB-laddstation",
    "Mobilholdere til bil": "Mobilhållare till bil",
    "Mobil holder": "Mobilhållare",
    "iPad Cover": "iPad-skal",
    "iPad Air Cover": "iPad Air-skal",
    "iPad Pro Cover": "iPad Pro-skal",
    "iPad Mini Cover": "iPad Mini-skal",
    "iPhone Trådløs oplader": "Trådlös iPhone-laddare",
    "iPhone Mikrofon": "iPhone-mikrofon",
    "iPhone Oplader": "iPhone-laddare",
    "iPhone Tripod": "iPhone-stativ",
    "Computer Sleeve": "Datorfodral",
    "MacBook Sleeve": "MacBook-fodral",
    "MacBook 13 Sleeve": "MacBook 13-fodral",
    "Fjernstyret drone": "Fjärrstyrd drönare",
    "Garmin Watch Remme": "Garmin-armband",
    "AirTag Nøglering": "AirTag-nyckelring",
    "AirPods Cover": "AirPods-fodral",
    "Mobilcover": "Mobilskal",
    "Samsung Cover": "Samsung-skal",
    "iPhone Kabel": "iPhone-kabel",
    "iPhone 17 Cover": "iPhone 17-skal",
    "iPhone 17 Pro Cover": "iPhone 17 Pro-skal",
    "iPhone 17 Pro Max Cover": "iPhone 17 Pro Max-skal",
    "iPhone 17 Air Cover": "iPhone 17 Air-skal",
    "iPhone 15 Cover": "iPhone 15-skal",
    "iPhone 15 Pro Cover": "iPhone 15 Pro-skal",
    "iPhone 15 Pro Max Cover": "iPhone 15 Pro Max-skal",
    "iPhone 15 Plus Cover": "iPhone 15 Plus-skal",
    "iPhone 14 Cover": "iPhone 14-skal",
    "iPhone 14 Pro Cover": "iPhone 14 Pro-skal",
    "iPhone 14 Pro Max Cover": "iPhone 14 Pro Max-skal",
    "iPhone 14 Plus Cover": "iPhone 14 Plus-skal",
    "iPhone 13 Cover": "iPhone 13-skal",
    "iPhone 13 Pro Cover": "iPhone 13 Pro-skal",
    "iPhone 13 Pro Max Cover": "iPhone 13 Pro Max-skal",
    "iPhone 13 Mini Cover": "iPhone 13 Mini-skal",
    "iPhone 12 Cover": "iPhone 12-skal",
    "iPhone 12 Pro Cover": "iPhone 12 Pro-skal",
    "iPhone 12 Pro Max Cover": "iPhone 12 Pro Max-skal",
    "iPhone 12 Mini Cover": "iPhone 12 Mini-skal"
  };
  var SWEDISH_ALT = {
    "Magsafe Ladestation til iPhone": "MagSafe-laddstation till iPhone",
    "Trådløse Earbuds": "Trådlösa earbuds",
    "Trådløs MagSafe Oplader til Bilen": "Trådlös MagSafe-laddare till bilen",
    "sense trådløs biloplader": "SENSE trådlös billaddare",
    "Lightning Opladnings Kabel": "Lightning-laddningskabel",
    "Anker 533 Powerbank": "Anker 533 powerbank",
    "44mm NX beskyttelsesglas der bliver sat på et Apple Watch": "44 mm NX-skyddsglas som monteras på en Apple Watch",
    "Aluminium Lænkeværktøj til skift af led i Metal": "Länkverktyg i aluminium för byte av metallänkar",
    "Ladedock i sort med et Apple Watch sat på": "Svart ladddocka med en Apple Watch",
    "Quick Charge Trådløs Docking Ladestation i sort": "Svart trådlös Quick Charge-laddstation",
    "Aluminium oplader stand i sølv, med et Apple Watch sat på den": "Silverfärgat laddställ i aluminium med en Apple Watch",
    "Magsafe Ladestation til Samsung Galaxy": "MagSafe-laddstation till Samsung Galaxy",
    "DeLX™ 3-i-1 Ladestation - Sort": "DeLX™ 3-i-1-laddstation - Svart",
    "X97 Magnetisk Mobilholder Sugekop 360° MagSafe kompatibel": "X97 magnetisk mobilhållare med sugkopp, 360° och MagSafe-kompatibilitet",
    "ESSAGER™ 45W USB Biloplader": "ESSAGER™ 45W USB-billaddare",
    "GaN-Pro™ 240W USB Ladestation": "GaN-Pro™ 240W USB-laddstation",
    "65W QuickCharge Vægoplader": "65W QuickCharge-väggladdare",
    "Professionel Drone 4K - GPS": "Professionell drönare 4K - GPS",
    "Bodytrimmer V.3.0": "Kroppstrimmer V.3.0",
    "4K Ultra HD Dashcam": "4K Ultra HD-dashcam",
    "Carplay Adapter til bil Carabc": "CarPlay-adapter till bil Carabc",
    "Lenovo™ LP40 trådløst Headset": "Lenovo™ LP40 trådlöst headset",
    "MagSafe Powerbank 5000mAh": "MagSafe-powerbank 5000 mAh",
    "ESSAGER™ 2-Port 20W - Sort": "ESSAGER™ 2-port 20W - Svart",
    "MagSafe Bilholder": "MagSafe-mobilhållare till bil",
    "wivu trådløs oplader i sort": "WIVU trådlös laddare i svart",
    "Baseus Biloplader til bilen": "Baseus billaddare",
    "USB-A til Lightning Kabel": "USB-A till Lightning-kabel",
    "Løbearmbånd til Smartphones i sort": "Svart löpararmband till smartphones",
    "Løbearmbånd til Smartphone": "Löpararmband till smartphone",
    "Lenovo™ 4Run Løbe/Fitness Ear Buds": "Lenovo™ 4Run earbuds för löpning och träning",
    "4K Starter Drone": "4K-drönare för nybörjare",
    "Sort Ægte læder Airtag nøglering": "Svart AirTag-nyckelring i äkta läder",
    "ROCK Over ear headset sort": "ROCK svart over-ear-headset",
    "Joyroom Højtaler i sort": "JOYROOM-högtalare i svart",
    "KUMI™ T9S In-Ear Touch Headset": "KUMI™ T9S in-ear touch-headset",
    "MONO Håndfri Øresnegl M. Etui": "MONO handsfree-headset med etui",
    "DG.MING™ Vintage 2-In-1 Cover": "DG.MING™ Vintage 2-i-1-fodral",
    "BASEUS Bilholder M. Trådløs Opladning Til Ventilationsgitteret": "BASEUS-mobilhållare med trådlös laddning för ventilationsgallret",
    "Multifunktionel Adapter til enheder": "Multifunktionell adapter till enheter",
    "Vægoplader i sort": "Svart väggladdare",
    "Webcam Kamera Beskyttelse til Computer": "Webbkameraskydd till dator",
    "Trådløs Mus til MacBook": "Trådlös mus till MacBook",
    "Stander i sølv til MacBooks": "Silverfärgat stativ till MacBook",
    "Rengørings spray til skærme": "Rengöringsspray för skärmar",
    "Quick Charge 3-i-1 Trådløs Docking Ladestation i sort": "Svart 3-i-1 trådlös Quick Charge-laddstation",
    "Hvid Magnetisk Trådløs Oplader": "Vit magnetisk trådlös laddare",
    "STANDART FORSIDE": "Mobilskal och tillbehör",
    "Sort iPhone på skrå i sort": "Svart iPhone i vinkel",
    "Sort Apple Watch med en Nylon rem": "Svart Apple Watch med nylonarmband",
    "Sort/Grå Apple iPad Pro 11 12,9": "Svart/grå Apple iPad Pro 11/12,9",
    "MacBook med åben skærm": "MacBook med öppen skärm",
    "Apple Logo opdelt i forskellige farver": "Apple-logotyp i olika färger",
    "sort delx 3-i-1 Opladestation": "Svart DeLX 3-i-1-laddstation",
    "Sorte Earpods": "Svarta earbuds",
    "Bilstøvsuger": "Mobilhållare till bil",
    "Gadgets spredt ud på en overflade": "Gadgets placerade på en yta",
    "Gadgets til bil bagrunds billede": "Banner med gadgets till bilen",
    "Gennemsigtig iPhone MagSafe Cover": "Genomskinligt MagSafe-skal till iPhone",
    "MagSafe tilbehør til iPhone": "MagSafe-tillbehör för iPhone"
  };


  /*
   * Homepage paragraphs containing links need to be replaced as complete HTML
   * blocks so the original links remain clickable.
   */
  var SWEDISH_COMPLEX_HTML = {
    "Er du på udkig efter iPhone covers, iPhone tilbehør, iPad covers, MacBook Sleeves, Apple Watch Remme, tilbehør og beskyttelse til din smartphone, så er du kommet til det helt rette sted.": `Letar du efter
      <a href="/pages/iphone-cover" target="_blank"><u>iPhone-skal</u></a>,
      <a href="/pages/iphone-tilbehor"><u>iPhone-tillbehör</u></a>,
      <a href="/pages/ipad_cover" target="_blank"><u>iPad-skal</u></a>,
      <a href="/pages/macbook-sleeve-taske" target="_blank"><u>MacBook-fodral</u></a>,
      <a href="/pages/apple_watch_remme_tilbehor" target="_blank"><u>Apple Watch-armband</u></a>,
      samt tillbehör och skydd till din smartphone, har du kommit helt rätt.`,

    "Vi sørger konstant for at have et meget varieret udvalg af tilbehør til mange forskellige typer af smartphones & iPhones fra en lang række forskellige producenter. Vi sælger blandt andet Støvsuger til bil, Ladestationer, In-ear høretelefoner, USB ladestation, Mobilholdere til bil, Mobil holder, tilbehør og beskyttelse til de fleste telefoner på markedet, og derudover sørger vi også altid for at have et bredt sortiment af udstyr til de lidt ældre modeller, så du ikke går forgæves, hvis din telefon har et par år på bagen.": `Vi ser hela tiden till att erbjuda ett brett och varierat utbud av tillbehör för många olika typer av smartphones och iPhones från flera olika tillverkare. Vi säljer bland annat
      <a href="/collections/stovsuger-til-bil" target="_blank"><u>bildammsugare</u></a>,
      <a href="/collections/mobil_opladerstation" target="_blank"><u>laddstationer</u></a>,
      <a href="/collections/in_ear_headset_horetelefoner" target="_blank"><u>in-ear-hörlurar</u></a>,
      <a href="/collections/a-usb-ladestation" target="_blank"><u>USB-laddstationer</u></a>,
      <a href="/collections/mobilholder-til-bil" target="_blank"><u>mobilhållare till bil</u></a> och
      <a href="/collections/mobil-stativ-mobilstander-bordholder" target="_blank"><u>mobilhållare</u></a>.
      Vi erbjuder tillbehör och skydd för de flesta telefoner på marknaden och har även ett brett sortiment för äldre modeller, så att du kan hitta rätt tillbehör även om din telefon har några år på nacken.`
  };

  /*
   * These replacements are a fallback for the MagSafe banner. They make the
   * Swedish images work even if the homepage is later changed back to the
   * original Danish image URLs.
   */
  var SWEDISH_IMAGE_SRC = {
    "A1_4238ddee-224e-4b45-8377-a676ca847f2c.png":
      "https://cdn.shopify.com/s/files/1/1563/9239/files/Sweden-Dekstop.png?v=1783941660",

    "A2_4ea9d09c-0d17-4ddc-8cc2-3ce5d31dbff0.png":
      "https://cdn.shopify.com/s/files/1/1563/9239/files/sweden_Mobile.png?v=1783941660"
  };

  var TRANSLATABLE_ELEMENTS = 'a, p, b, u, h1, h2, h3, h5, span, .Shipping';

  function normalizeHtml(value) {
    var holder = document.createElement('div');
    holder.innerHTML = String(value || '').replace(/<br\s*\/?>/gi, '[[DC_BR]]');

    return (holder.textContent || holder.innerText || '')
      .replace(/\s*\[\[DC_BR\]\]\s*/g, '<br>')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function buildNormalizedMap(source) {
    var output = {};
    Object.keys(source).forEach(function (key) {
      output[normalizeHtml(key)] = source[key];
    });
    return output;
  }

  var NORMALIZED_TEXT = buildNormalizedMap(SWEDISH_TEXT);
  var NORMALIZED_ALT = buildNormalizedMap(SWEDISH_ALT);
  var NORMALIZED_COMPLEX_HTML = buildNormalizedMap(SWEDISH_COMPLEX_HTML);

  function containsOnlyLineBreakElements(element) {
    for (var i = 0; i < element.children.length; i += 1) {
      if (element.children[i].tagName !== 'BR') return false;
    }
    return true;
  }

  function translateTextElement(element) {
    if (!element || !containsOnlyLineBreakElements(element)) return;

    var key = normalizeHtml(element.innerHTML);
    var translated = NORMALIZED_TEXT[key];

    if (translated && translated !== element.innerHTML) {
      element.innerHTML = translated;
    }
  }

  function translateComplexElement(element) {
    if (!element) return;

    var key = normalizeHtml(element.innerHTML);
    var translated = NORMALIZED_COMPLEX_HTML[key];

    if (translated && translated !== element.innerHTML) {
      element.innerHTML = translated;
    }
  }

  function replaceImageSource(image) {
    if (!image) return;

    var currentSource = image.getAttribute('src') || '';
    var filenames = Object.keys(SWEDISH_IMAGE_SRC);

    for (var i = 0; i < filenames.length; i += 1) {
      var filename = filenames[i];

      if (currentSource.indexOf(filename) !== -1) {
        var replacement = SWEDISH_IMAGE_SRC[filename];

        if (currentSource !== replacement) {
          image.setAttribute('src', replacement);

          if (image.hasAttribute('srcset')) {
            image.removeAttribute('srcset');
          }
        }

        break;
      }
    }
  }

  function translateImageAlt(image) {
    if (!image || !image.hasAttribute('alt')) return;

    var key = normalizeHtml(image.getAttribute('alt'));
    var translated = NORMALIZED_ALT[key] || NORMALIZED_TEXT[key];

    if (translated) {
      image.setAttribute('alt', translated.replace(/<br\s*\/?>/gi, ' '));
    }
  }

  function translateRoot(root) {
    if (!root) return;

    if (root.nodeType === 1) {
      if (root.matches && root.matches('.SEOText.bottomPart p')) translateComplexElement(root);
      if (root.matches && root.matches(TRANSLATABLE_ELEMENTS)) translateTextElement(root);

      if (root.matches && root.matches('img')) {
        replaceImageSource(root);
        translateImageAlt(root);
      }
    }

    if (!root.querySelectorAll) return;

    var complexElements = root.querySelectorAll('.SEOText.bottomPart p');
    for (var i = 0; i < complexElements.length; i += 1) {
      translateComplexElement(complexElements[i]);
    }

    var textElements = root.querySelectorAll(TRANSLATABLE_ELEMENTS);
    for (var j = 0; j < textElements.length; j += 1) {
      translateTextElement(textElements[j]);
    }

    var images = root.querySelectorAll('img');
    for (var k = 0; k < images.length; k += 1) {
      replaceImageSource(images[k]);
      translateImageAlt(images[k]);
    }
  }


  function applyHomepageFallbacks() {
    var noveltyHeadings = document.querySelectorAll('.Maintext h3');
    for (var i = 0; i < noveltyHeadings.length; i += 1) {
      var noveltyKey = normalizeHtml(noveltyHeadings[i].innerHTML);
      if (noveltyKey === 'NYHED' || noveltyKey === 'NYHED<br>') {
        noveltyHeadings[i].innerHTML = 'NYHET<br>';
      }
    }

    var gadgetHeadings = document.querySelectorAll('.centeredTT h1 b');
    for (var j = 0; j < gadgetHeadings.length; j += 1) {
      if (normalizeHtml(gadgetHeadings[j].innerHTML) === 'Gadgets til bilen') {
        gadgetHeadings[j].textContent = 'Gadgets till bilen';
      }
    }

    var gadgetDescriptions = document.querySelectorAll('.centeredTT p');
    for (var k = 0; k < gadgetDescriptions.length; k += 1) {
      if (normalizeHtml(gadgetDescriptions[k].innerHTML) === 'Alt i udstyr og gadgets til bil') {
        gadgetDescriptions[k].textContent = 'Allt inom utrustning och gadgets till bilen';
      }
    }
  }

  function start() {
    translateRoot(document);
    applyHomepageFallbacks();

    if (!window.MutationObserver || !document.body) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var addedNodes = mutations[i].addedNodes;
        for (var j = 0; j < addedNodes.length; j += 1) {
          translateRoot(addedNodes[j]);
        }
      }

      applyHomepageFallbacks();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
